/**
 * كلمةٌ مؤقّتةٌ مقترَحة — <b>من `crypto` لا من `Math.random`</b>.
 *
 * ‏`Math.random` ليست عشوائيّةً تشفيريًّا: بذرتُها تُخمَّن، ومن رأى بضع مخرجاتٍ
 * منها استطاع توقّعَ ما بعدها. وكلمةٌ مؤقّتةٌ متوقَّعةٌ أسوأ من لا شيء، لأنّها
 * تبدو قويّةً وهي ليست كذلك.
 *
 * والمقترَحُ كلماتٌ عربيّةٌ مفصولة، لا `Xq7!vB2z`: الكلمةُ تُقرأ من الشاشة
 * وتُملى على الموظّف شفهيًّا ثمّ يكتبها على هاتفٍ لوحتُه عربيّة. فما لا يُملى
 * يُكتب على ورقةٍ ويُترك على الطاولة — وهذا هو التسريبُ الحقيقيّ، لا ضعفُ
 * المحارف. وأربعُ كلماتٍ من مئةٍ تعني عشرةً ملايين احتمالٍ للترتيب الواحد،
 * وهي تُغيَّر عند أوّل دخولٍ أصلًا.
 */

const WORDS = [
  'قمر', 'شمس', 'بحر', 'جبل', 'نهر', 'غيم', 'مطر', 'ريح', 'نجم', 'فجر',
  'ليل', 'صبح', 'ظل', 'نور', 'ورد', 'نخل', 'زيت', 'ملح', 'عسل', 'تين',
  'رمل', 'صخر', 'واد', 'سهل', 'حقل', 'بئر', 'عين', 'درب', 'جسر', 'باب',
  'خيط', 'حبل', 'قلم', 'ورق', 'كتاب', 'حرف', 'سطر', 'رقم', 'حجر', 'طين',
  'خشب', 'حديد', 'نحاس', 'ذهب', 'فضة', 'زجاج', 'قماش', 'جلد', 'صوف', 'قطن',
]

/** عددٌ عشوائيٌّ في [0, max) بلا انحياز. */
function randomBelow(max: number): number {
  const limit = Math.floor(0xffffffff / max) * max
  const buffer = new Uint32Array(1)

  // ⚠ الرفضُ وإعادةُ السحب لا `% max` مباشرةً: باقي القسمة يجعل الأوائلَ
  // أكثرَ احتمالًا من الأواخر، فينكمش الفضاءُ بلا أن يلاحظ أحد.
  let value: number

  do {
    crypto.getRandomValues(buffer)

    // ‏`!` لأنّ `Uint32Array(1)` فيها الخانةُ صفر بالتأكيد — والحزمةُ تُفحص
    // بـ`noUncheckedIndexedAccess` (أصرمَ من إعداد التطبيقات)، فيُقال هذا
    // صراحةً بدل أن يُخفَّف الإعداد لأجل سطر.
    value = buffer[0]!
  } while (value >= limit)

  return value % max
}

/** أربعُ كلماتٍ ورقمان — أطولُ من الحدّ الأدنى دائمًا. */
export function suggestPassword(): string {
  // والمؤشّرُ داخلَ المدى بالبناء: `randomBelow(WORDS.length)` لا يتجاوزها.
  const words = Array.from({ length: 4 }, () => WORDS[randomBelow(WORDS.length)]!)

  return `${words.join('-')}-${randomBelow(90) + 10}`
}
